// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__yRe8t","imageWrapper":"styles_imageWrapper__KEkr1","loader":"styles_loader__h_rSY"};